import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from '../../../services/toast.service';
import { LoaderService } from '../../../services/loader.service';
import { ContactService } from '../../../services/contact.service';
import { PageTitleService } from '../../../services/page-title.service';

@Component({
  selector: 'psc-contact-us',
  templateUrl: './contact-us.component.html',
})
export class ContactUsComponent implements OnInit {
  formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private toastService: ToastService,
    private loaderService: LoaderService,
    private contactService: ContactService,
    private pageTitleService: PageTitleService,
  ) {
    /**
     * t(title.contact-us)
     */
    this.pageTitleService.setTitle('title.contact-us');
  }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      subject: ['', Validators.required],
      message: ['', Validators.required],
    });
  }

  onSubmit() {
    if (!this.formGroup.valid) {
      return;
    }
    this.loaderService.showLoader();
    this.contactService.sendContactQuery(this.formGroup.value).subscribe({
      next: () => {
        /**
         * t(toast.contact_us)
         * */
        this.toastService.showSuccessToast('toast.contact_us');
        this.formGroup.reset();
        this.formGroup.markAsPristine();
      },
    }).add(() => {
      this.loaderService.hideLoader();
    });
  }
}
